module.exports = __webpack_public_path__ + "img/quality-halal.5f3ee7ae.png";